import { render, staticRenderFns } from "./TrainModel.vue?vue&type=template&id=45f5c9bf&scoped=true"
import script from "./TrainModel.vue?vue&type=script&lang=js"
export * from "./TrainModel.vue?vue&type=script&lang=js"
import style0 from "./TrainModel.vue?vue&type=style&index=0&id=45f5c9bf&prod&lang=less&scoped=true"
import style1 from "./TrainModel.vue?vue&type=style&index=1&id=45f5c9bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5c9bf",
  null
  
)

export default component.exports